import { render } from "./form2.vue?vue&type=template&id=55988328&scoped=true&ts=true"
import script from "./form2.vue?vue&type=script&lang=ts"
export * from "./form2.vue?vue&type=script&lang=ts"

import "./form2.vue?vue&type=style&index=0&id=55988328&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55988328"]])

export default __exports__